/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable no-underscore-dangle */

import _ from 'lodash';

function isNonEmptyString(text) {
  return text !== '' && text !== null && text !== undefined;
}

export interface Profile {
  residence_country_id: number;
  residence_state_id: number;
  given_names: string;
  family_names: string;
  preferred_name: string;
}

class ProfileModel {

  static isProfileComplete(data) {
    const profile = new ProfileModel(data);

    return profile.hasPreferredName() && profile.hasGivenOrFamilyName();
  }

  static fullName(data) {
    return new ProfileModel(data).fullName();
  }

  constructor(private data: Partial<Profile> = {}) {
  }

  fullName() {
    const given = this.data.given_names || '';
    const family = this.data.family_names || '';
    let preferred = this.data.preferred_name || '';

    if (given === preferred || _.includes(given.split(' '), preferred)) {
      preferred = '';
    } else if (family === preferred || _.includes(given.split(' '), preferred)) {
      preferred = '';
    }

    if (preferred) {
      preferred = `(${preferred})`;
    }

    return _.compact([given, family, preferred]).join(' ');
  }

  hasPreferredName() {
    return isNonEmptyString(this.data.preferred_name);
  }

  hasGivenOrFamilyName() {
    const hasGivenName = isNonEmptyString(this.data.given_names);
    const hasFamilyName = isNonEmptyString(this.data.family_names);
    return hasGivenName || hasFamilyName;
  }

}

export default ProfileModel;
